import { FC } from "react";
import { Rect, Svg } from "react-native-svg";

import { tSvgProps } from "../types";

const PdMenu: FC<tSvgProps> = (props) => (
  <Svg viewBox="0 0 30 22" fill="none" {...props}>
    <Rect width="30" height="1.5" fill="currentColor" />
    <Rect y="10" width="22" height="1.5" fill="currentColor" />
    <Rect y="20" width="30" height="1.5" fill="currentColor" />
  </Svg>
);

export default PdMenu;
